/*eslint-disable*/
export default [
    {
        path: 'tariffs',
        name: 'tariffs:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_tariffs',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'tariffs',
                page: $route.query.page,
                withoutCreate: false,
            }
        }
    },
    {
        path: 'tariffs/:id/edit',
        name: 'tariffs:edit',
        component: () => import('../../components/tariffs/Edit.vue'),
        meta: {
            title: 'router.router_tariffs',
            prev: {
                name: 'tariffs:list'
            }
        },
        props ($route) {
            return {
                id: $route.params.id,
                type: $route.params.type || 'tariffs',
                page: $route.query.page,
                copy: $route.params.copy,
            }
        }
    },
]
